import React from "react";
import ErrorGif from "../assets/backgrounds/error.gif"

function ErrorPage() {
    return (
        <img src={ErrorGif} alt="gif" style={{height: "90vh", width: "100vw"}}/>
    )
}

export default ErrorPage